import React from "react";
import { useSelector } from "react-redux";
import isEmpty from "lodash/isEmpty";

import { AlertText, alertTypes } from "shared/dist/components";
import { serviceIdAvailability } from "../constant";

import classes from "./ServiceProfileImageUpload.module.css";

const ServiceIdAvailability = ({ id, availability }) => {
    const isValidateServiceIdLoading = useSelector(
        (state) => state.loader.validateServiceId.isLoading
    );

    if (!Boolean(id)) {
        return null;
    }
    if (isValidateServiceIdLoading) {
        return (
            <div className={classes.alertTextContainer}>
                <AlertText type={alertTypes.INFO} message="validating..." />
            </div>
        );
    }

    const type =
        availability === serviceIdAvailability.AVAILABLE ? alertTypes.SUCCESS : alertTypes.ERROR;

    const message = !isEmpty(id) && Boolean(availability) ? `Service Id is ${availability}` : "";

    return (
        <div className={classes.alertTextContainer}>
            <AlertText type={type} message={message} />
        </div>
    );
};

export default ServiceIdAvailability;
